module.exports = __webpack_public_path__ + "img/banadores-y-lenceria.bc17ac90.jpg";